import React from "react";
import logo from './assets/logo.webp'



// Real BE1 brand logo with glow
export const Logo = ({ size = "md", className = "", glow = true }) => {
const sizes = {
  sm: "h-8",
  md: "h-10",
  lg: "h-16",
  xl: "h-24",
  hero: "h-32 sm:h-40 md:h-44 lg:h-44",
};

  return (
    <div
      className={`inline-flex items-center select-none ${className}`}
      data-testid="be1-logo"
    >
      <img
        src={logo}
        alt="BE1 — Software Studio"
        draggable={false}
        className={`${sizes[size] || sizes.md} w-auto object-contain`}
        style={{
          filter: glow
            ? "drop-shadow(0 0 18px rgba(0,170,255,0.55)) drop-shadow(0 0 60px rgba(0,85,255,0.25))"
            : "none",
        }}
      />
    </div>
  );
};

export default Logo;
